import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import AboutBio from '../components/about/AboutBio';
import AboutSidebar from '../components/about/AboutSidebar';

const About = () => (
  <div data-testid="about-page">
    <section className="min-h-screen bg-beige-light pt-32 pb-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-5xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <p className="text-sm tracking-widest uppercase text-pink-deep font-sans mb-6">About</p>
          <h1 className="text-5xl md:text-6xl font-serif font-bold tracking-tight text-brown-deep mb-12" data-testid="about-title">
            A Literary Voice Across Borders
          </h1>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <AboutBio />
          <AboutSidebar />
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default About;
